/**
 * Adapptio Core Library
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	createEmptyScope,
	functionMapToScopeData,
	IFunctionResolver,
	IScope,
	RuntimeContext,
	RUNTIME_CONTEXT_MODE,
	Type
} from "@adapptio/lib-blueprint";
import { IViewParamsSpec } from "@adapptio/lib-shared";
import { IViewGlobals } from "../globals/IViewGlobals";
import { IGlobalsResolver } from "../resolvers/IGlobalsResolver";

export function createViewScope(rCtx: RuntimeContext, viewParamsSpec: IViewParamsSpec): IScope {
	const globals = rCtx.getResolver<IGlobalsResolver<IViewGlobals>>("globals").getGlobals();
	const fnScopeMap = functionMapToScopeData(
		rCtx.getResolver<IFunctionResolver>("function").getFunctionMap(),
		rCtx.getMode() === RUNTIME_CONTEXT_MODE.EDITOR
	);

	return createEmptyScope(
		{
			globals: {
				...fnScopeMap.data
			},
			...globals.data,
			params: viewParamsSpec
		},
		{
			globals: Type.Object({
				props: {
					...fnScopeMap.type
				}
			}),
			...(globals.type?.props || {})
			// @todo add params type descriptor
		}
	);
}
